<template>
  <div>
    <!--<a :href="url" target="_blank" class="link flex items-center">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-1">
        <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
      </svg>
      View File
    </a>-->
    <p class="link flex items-center" @click="viewFileClicked" v-if="url">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-1">
        <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
      </svg>
      View File
    </p>

    <b-modal size="xl" ref="viewFile" :title="displayTitle" class="text-center">
      <a :href="url" target="_blank" class="link flex items-center justify-center mb-2">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-1">
          <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
        </svg>
        View In New Tab
      </a>
      <div v-if="!safeURL.includes('.pdf')">
        <img :src="url" class="w-full"/>
      </div>
      <iframe v-else class="w-full h-96 border" style="height: 75vh;" :src="url">
      </iframe>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    title: String
  },
  methods: {
    viewFileClicked () {
      this.$refs.viewFile.show()
    }
  },
  computed: {
    displayTitle () {
      return this.title || 'View File'
    },
    safeURL () {
      return this.url || ''
    }
  }
}
</script>

<style>

</style>
